import { graphql } from "../generated";

export const SearchLineWithLanguage = graphql(
  `
    query SearchLineWithLanguage(
      $filter: SearchableLinesFilterInput!
      $limit: Int!
    ) {
      searchAuthorizedLines(filter: $filter, limit: $limit) {
        items {
          ...SearchLineDetails
        }
      }
    }
  `
);
